import React from "react";
import { render } from 'react-dom';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import {Provider} from 'react-redux';
import 'font-awesome/css/font-awesome.min.css';
import "animate.css";
import 'Ncontracts.Common.UI/dist/bundle.css';
import 'bulma';
import './styles/_site.scss';
import configureStore from './store/configStore';
import Home from "./components/HomeComponent";
// import AuthContainer from "./components/AuthContainer";

const store = configureStore();

render (
    <Provider store={store}>
        <Router>
            <div>
                <Switch>
                    {/*<Route path="/redirect/:nonce" component={AuthContainer} />*/}
                    <Route path="/" component={Home} />
                </Switch>
            </div>
        </Router>
    </Provider>,
    document.getElementById('app')
);
